export const TermsActionTypes = {
  ACTIVE_TERMS_LOADING: "TERMS/ACTIVE_TERMS_LOADING",
  ACTIVE_TERMS_SUCCESS: "TERMS/ACTIVE_TERMS_SUCCESS",
  ACTIVE_TERMS_FAIL: "TERMS/ACTIVE_TERMS_FAIL",
};
